<app-header></app-header>
<app-sidebar
  ativo="CRM">
</app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <div class="row">
      <div class="col-md-6">
        <app-breadcrumb
          Titulo="CRM"
          Pagina="CRM"
        ></app-breadcrumb>
      </div>
    </div>
    <div class="crm-workspace">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-11 pull-left crm-acoes" style="margin-bottom: 10px;">
            <button (click)="showModalCliente=true" class="btn btn-primary"
                    style="height: 40px; margin-left: 10px;float:left">Novo cliente
            </button>
            <button (click)="showModalCompromisso=true" class="btn btn-primary"
                    style="height: 40px; margin-left: 10px;float:left">Nova tarefa
            </button>
            <button (click)="showModal=true" class="btn btn-primary" style="height: 40px; margin-left: 10px;float:left">Novo lead
            </button>
            <button class="btn btn-default"
                    style="height: 40px; margin-left: 30px; float:left; padding: 0; display: flex; align-items: center; border-radius: 5px; overflow: hidden;"
                    *ngIf="lista">
              <input type="text" name="busca" class="form-control"
                     style="height: 40px; width: 400px; border: none; box-shadow: none;" placeholder="Buscar">
              <i class="fa fa-search icone-busca"
                 style="height: 100%; margin-right: 0; display: flex; align-items: center;"></i>
            </button>

          </div>
          <div class="col-md-1 pull-right crm-visualizacao">
            <div class="botoes pull-right">
              <div class="icone" (click)="lista=false" [ngClass]="{'active': !lista}" matTooltip="Visualizar Kanbam"><i
                class="fa fa-bar-chart-o"></i></div>
              <div class="icone" (click)="lista=true" [ngClass]="{'active': lista}" matTooltip="Visualizar lista"><i
                class="fa fa-list"></i></div>
            </div>
          </div>
          <div class="col-md-12" *ngIf="lista">
            <div class="row" style="margin-top: 10px;">
              <div class="col-12">
                <div class="card">
                  <div class="card-body table-responsive p-0">
                    <table class="table table-head-fixed table-striped">
                      <thead style="z-index: 1 !important;position: relative;">
                      <tr>
                        <th>Cliente</th>
                        <th>Descrição</th>
                        <th>Valor</th>
                        <th>Status</th>
                        <th>Cadastro</th>
                        <th style="width: 20px">*</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                        *ngFor="let linha of listaAtendimento.itens | paginate: { itemsPerPage: 10, currentPage: paginaAtual }">
                        <td>{{ linha.solicitante }}</td>
                        <td>{{linha.descricaoResumida}}</td>
                        <td>R$ {{ linha.valor }}</td>
                        <td>
                          <div class="badge"
                               [ngClass]="{
                               'bg-afazer': linha.status === 0,
                               'bg-andamento': linha.status === 7,
                               'bg-validacao': linha.status === 4,
                               'bg-assinatura': linha.status === 5,
                               'bg-fechado': linha.status === 6
                             }">
                            {{
                              linha.status === 0 ? 'Contato inicial' :
                                linha.status === 7 ? 'Agendado' :
                                  linha.status === 4 ? 'Aprovação' :
                                    linha.status === 5 ? 'Aguardando assinatura' :
                                    'Fechado'
                            }}
                          </div>
                        </td>
                        <td>{{ linha.dataCadastro | date: 'dd/MM/yyyy' }}</td>
                        <td>
                          <a href="cadastro/atendimento/detalhes/{{linha.id}}">
                            <button class="btn btn-warning" style="margin-right: 10px"><i class="fa fa-edit"></i>
                            </button>
                          </a>
                        </td>
                      </tr>
                      <tr *ngIf="listaAtendimento.itens.length == 0">
                        <td colspan="10" class="text-center text-orange">Nenhum registro a ser mostrado</td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="text-center">
                        <td [attr.colspan]="8">
                          <pagination-controls class="pagination-sm"
                                               [autoHide]="false"
                                               [directionLinks]="true"
                                               previousLabel="Anterior"
                                               nextLabel="Próximo"
                                               (pageChange)="pageChange($event)">
                          </pagination-controls>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12" *ngIf="!lista">
            <app-kanbam

            ></app-kanbam>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<app-cadastro-novo-atendimento
  (fecharModalPai)="fecharModal()"
  [showModal]=showModal
></app-cadastro-novo-atendimento>
<app-novo-compromisso
  [showModal]=showModalCompromisso
  (fecharModalPai)="fecharModal()"
>
</app-novo-compromisso>
<app-cadastro-novo-contato
  [showModal]=showModalCliente
  (fecharModalPai)="fecharModal()"
></app-cadastro-novo-contato>
